<template>
  <div class="message-card">
    <!-- 卡片头部 -->
    <div class="msg-card-header">
      <span class="card-title">{{ $t('workbench.digitalTwin') }}</span>
      <!-- <button class="fullscreen-btn" @click="toggleFullscreen" title="全屏">
        <i :class="isFullscreen ? 'el-icon-full-screen' : 'el-icon-full-screen'"></i>
      </button> -->
    </div>

    <!-- 内容区域 - iframe嵌入 -->
    <div class="data-card-content" :class="{ 'classic-mode': !isSmartMode }">
      <iframe
        :src="iframeUrl"
        class="data-iframe"
        frameborder="0"
        allowfullscreen
        @load="handleIframeLoad"
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DataTwins',
  data() {
    return {
      iframeUrl:
        'https://lingzhi-light3d.hdt.cosmoplat.com/preview/5372?type=iframe&factoryDirector=true',
      isIframeLoaded: false,
      isFullscreen: false
    }
  },
  computed: {
    isSmartMode() {
      // 基于路由判断智擎模式
      const path = this.$route.path
      return path.startsWith('/smart-engine') || path.includes('dashboard')
    }
  },
  mounted() {
    // 监听全屏状态变化
    document.addEventListener('fullscreenchange', this.handleFullscreenChange)
    document.addEventListener(
      'webkitfullscreenchange',
      this.handleFullscreenChange
    )
    document.addEventListener(
      'mozfullscreenchange',
      this.handleFullscreenChange
    )
    document.addEventListener('msfullscreenchange', this.handleFullscreenChange)
  },
  beforeUnmount() {
    // 移除监听
    document.removeEventListener(
      'fullscreenchange',
      this.handleFullscreenChange
    )
    document.removeEventListener(
      'webkitfullscreenchange',
      this.handleFullscreenChange
    )
    document.removeEventListener(
      'mozfullscreenchange',
      this.handleFullscreenChange
    )
    document.removeEventListener(
      'msfullscreenchange',
      this.handleFullscreenChange
    )
  },
  methods: {
    handleIframeLoad() {
      this.isIframeLoaded = true
    },
    toggleFullscreen() {
      const container = document.querySelector('.data-card-content')
      if (!container) return

      if (!this.isFullscreen) {
        // 进入全屏
        if (container.requestFullscreen) {
          container.requestFullscreen()
        } else if (container.webkitRequestFullscreen) {
          container.webkitRequestFullscreen()
        } else if (container.mozRequestFullScreen) {
          container.mozRequestFullScreen()
        } else if (container.msRequestFullscreen) {
          container.msRequestFullscreen()
        }
      } else {
        // 退出全屏
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        }
      }
    },
    handleFullscreenChange() {
      this.isFullscreen = !!(
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.no-data {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 12px;
  color: #999999;
  line-height: 12px;
}
.message-card {
  background: #ffffff;
  border-radius: 8px;
  padding: 16px;
}

.msg-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;

  .card-title {
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    font-size: 14px;
    color: #333333;
  }

  .header-tag {
    font-weight: 300;
    font-size: 12px;
    color: #cccccc;
    line-height: 12px;
  }
}

.data-card-content {
  margin: 0 auto;
  // max-width: 40vw;
  max-width: 100%;
  height: 20vw;
  overflow: hidden;

  &.classic-mode {
    max-width: 100%;
    height: 30vw;
  }
}

.data-iframe {
  width: 100%;
  height: 100%;
  border: none;
}

/* 全屏按钮 */
.fullscreen-btn {
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 4px;
  background: #f5f6fe;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
  font-size: 16px;
  transition: all 0.2s ease;

  &:hover {
    background: #e8eaf6;
    color: #3370ff;
  }

  &:active {
    background: #dce0f5;
  }
}

/* 全屏状态样式 */
:deep(.fullscreen .message-card) {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 20px;
  border-radius: 0;
  z-index: 9999;
  box-sizing: border-box;
}

:deep(.fullscreen .data-card-content) {
  max-width: 100%;
  height: calc(100% - 60px);
}

/* 加载状态指示器 */
.iframe-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 14px;
  color: #999;
}
</style>
